import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPackageOut"><Path fillRule="evenodd" clipRule="evenodd" d="M2.99816 3H20.9982V21H12.9982V19.5H19.4982V4.5H15.9982V10H7.99816V4.5H4.49816V10H2.99816V3ZM5.80882 13.75L4.30882 15.25H7.24816C8.76694 15.25 9.99816 16.4812 9.99816 18V21H8.49816V18C8.49816 17.3096 7.93852 16.75 7.24816 16.75H4.30882L5.80882 18.25L4.74816 19.3107L1.4375 16L4.74816 12.6893L5.80882 13.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageOut;
